import { render } from "./ResourcesSteps.vue?vue&type=template&id=7e5d0868&scoped=true&ts=true"
import script from "./ResourcesSteps.vue?vue&type=script&lang=ts"
export * from "./ResourcesSteps.vue?vue&type=script&lang=ts"

import "./ResourcesSteps.vue?vue&type=style&index=0&id=7e5d0868&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e5d0868"]])

export default __exports__